import { PropsWithChildren, useCallback, useState } from "react";

import { useIsQaScannerEnabled } from "@components/QaReview/hooks/useIsQaScannerEnabled";
import { useIsReportCompleted, useIsReviewPage } from "@components/ReportField/capabilities/flags";
import { useReportOptional } from "@providers/ReportProvider";
import { SidebarView, SidebarViewContext } from "@providers/SidebarViewProvider/useSidebarView";

// Which view the report page's right column shows: the review panel or the table of contents. The
// clinician's own choice wins; it is dropped when they leave the review page, the report is
// completed, or another report opens in the same page (a review link from the bell), so the next
// visit starts from the default again.
export const SidebarViewProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const isQaScannerEnabled = useIsQaScannerEnabled();
  const isReviewPage = useIsReviewPage();
  const isReportCompleted = useIsReportCompleted();
  const reportId = useReportOptional()?.report.id;
  const [choice, setChoice] = useState<{ view: SidebarView; reportId: string | undefined } | null>(null);

  if (choice !== null && (!isReviewPage || isReportCompleted || choice.reportId !== reportId)) setChoice(null);
  const setView = useCallback((view: SidebarView) => setChoice({ view, reportId }), [reportId]);

  const defaultView: SidebarView = isQaScannerEnabled && !isReportCompleted ? "review" : "toc";

  return (
    <SidebarViewContext
      value={{
        view: choice?.view ?? defaultView,
        setView,
      }}
    >
      {children}
    </SidebarViewContext>
  );
};
